import {Box, Grid, styled} from '@mui/material';
import {Color} from '../../common/theme';

const BackgroundBox = styled(Box)({
    height: 400,
    paddingTop: 64,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
});

export const NotFoundScreen = () => {
    return (
        <div>
            <BackgroundBox>
                <Grid container>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <center>
                            <img src='/404.png' height={256} width={256} />
                        </center>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item md={2} />
                    <Grid item md={8}>
                        <span
                            style={{
                                fontSize: 54,
                                color: Color.BLACK,
                                fontWeight: 700,
                                fontFamily: 'Poppins',
                            }}>
                            <center>Website Not Found</center>
                        </span>
                    </Grid>
                </Grid>
                <Grid style={{marginTop: 12}} container>
                    <Grid item md={3} />

                    <Grid item md={6}>
                        <span
                            style={{
                                fontSize: 20,
                                color: Color.BLACK,
                                fontWeight: 200,
                                fontFamily: 'Poppins',
                            }}>
                            <center>
                                Oops we couldn’t find this page <br />
                                Get your business online in a few seconds.
                            </center>
                        </span>
                    </Grid>
                </Grid>
                <br />
                <Grid style={{marginTop: 45}} container>
                    <Grid item md={4} />
                    <Grid item md={4}>
                        <Box
                            style={{
                                backgroundColor: '#027dff',
                                paddingLeft: 2,
                                paddingRight: 2,
                                paddingTop: 15,
                                paddingBottom: 15,
                                borderRadius: 32,
                                cursor: 'pointer',
                            }}>
                            <div
                                onClick={() => {
                                    window.location.href = '/';
                                }}
                                style={{
                                    fontSize: 20,
                                    color: 'rgb(169, 203, 255)',
                                    fontWeight: 700,
                                    fontFamily: 'Poppins',
                                }}>
                                <center>Get Started</center>
                            </div>
                        </Box>
                    </Grid>
                </Grid>
            </BackgroundBox>
        </div>
    );
};
